import React, { ReactElement } from 'react';
import { WisoryButton, ButtonProps } from 'components/WisoryButton';

const ArrowRightIcon = () => {
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 6.179a1.11 1.11 0 0 0-.347-.825L9.638.347C9.402.116 9.142 0 8.86 0c-.329 0-.593.103-.794.308-.205.2-.308.45-.308.748 0 .169.033.318.1.446.062.134.144.252.247.355L9.83 3.582l2.55 2.343.477-.702-2.997-.161H1.156c-.35 0-.63.102-.84.308-.21.205-.316.475-.316.809 0 .334.105.603.316.809.21.205.49.308.84.308H9.86l2.997-.162-.477-.701-2.55 2.342-1.726 1.733a1.257 1.257 0 0 0-.247.347c-.067.134-.1.285-.1.455 0 .298.103.547.308.747.2.205.465.308.794.308.133 0 .27-.03.408-.092.134-.057.26-.144.378-.262l5.007-5.008c.231-.22.347-.495.347-.824z"
        fill="#fff"
      />
    </svg>
  );
};

export function NextButton(props: ButtonProps): ReactElement {
  return <WisoryButton {...props} variant="primary" icon={<ArrowRightIcon />} />;
}
